import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { action, observable, observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Cons from '../../isomorphic/cons';
import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';
import WorkflowStepTransitionModel from './workflow-step-transition-model';
import moment from 'moment';

@inject('appStore')
@observer
export default class WorkflowStepStateNotApplicableTransitionModal extends Component {
    constructor() {
        super();
        const fields = [
                {
                    name: 'reasonText',
                    label: 'reason',
                    rules: 'required|string|max:280',
                },
            ],
            plugins = {
                dvr: {
                    package: validatorjs,
                    extend: $validator => {
                        const messages = $validator.getMessages('en');
                        messages.required = 'Please enter a :attribute.';
                        $validator.setMessages('en', messages);
                    },
                },
            };

        this.form = new MobxReactForm({ fields }, { plugins });
    }

    onSuccess(form) {
        const values = form.values(),
            newTransition = new WorkflowStepTransitionModel();

        newTransition.reasons.push(values.reasonText);
        newTransition.createdOn = moment().format();
        newTransition.status =
            this.props.step.state.latestTransition &&
            this.props.step.state.latestTransition.status === Cons.transitionTypes.NotApplicable
                ? ''
                : Cons.transitionTypes.NotApplicable;

        this.props.saveNewStepTransition(newTransition);
        this.props.hide();
    }

    onError(form) {}

    submitForm(e) {
        this.form.onSubmit(e, { onSuccess: this.onSuccess.bind(this), onError: this.onError.bind(this) });
    }

    render() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.hide}
                onShow={() => {
                    this.form.clear();
                }}
            >
                <Modal.Body>
                    <form className="free-text-reason-form">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                                <div className="form-group">
                                    <label htmlFor={this.form.$(`reasonText`).id}>
                                        {this.props.step.state.latestTransition &&
                                        this.props.step.state.latestTransition.status ===
                                            Cons.transitionTypes.NotApplicable
                                            ? 'Why is this applicable again?'
                                            : 'Why is this not applicable?'}
                                    </label>
                                    <span
                                        style={{
                                            fontSize: 10,
                                            marginLeft: 10,
                                        }}
                                    >
                                        Maximum 280 characters ( {280 - this.form.$(`reasonText`).value.length}{' '}
                                        remaining)
                                    </span>
                                    <textarea
                                        rows={5}
                                        className="form-control"
                                        {...this.form.$(`reasonText`).bind()}
                                        autoFocus={true}
                                    />
                                    <p className="form-error">{this.form.$(`reasonText`).error}</p>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12">
                        <button
                            className="btn btn-primary pull-right"
                            onClick={this.submitForm.bind(this)}
                            disabled={appStore.workflowStore.isLoading || this.form.$(`reasonText`).value.length <= 0}
                        >
                            {this.props.step.state.latestTransition &&
                            this.props.step.state.latestTransition.status === Cons.transitionTypes.NotApplicable
                                ? 'Mark as Applicable'
                                : 'Mark as N/A'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-default pull-right"
                            style={{ marginRight: 10 }}
                            onClick={this.props.hide}
                        >
                            Cancel
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}
WorkflowStepStateNotApplicableTransitionModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/workflow/workflow-step-state-na-transition-modal.js